import React from 'react';
import ErrorDialog from '../components/ErrorDialog';
import navigateTo from '../helpers/navigation';
import { PUBLIC_URL } from '../constants';
import { useIntl } from 'react-intl';

type oAuthError =
  | 'invalid_request'
  | 'invalid_client'
  | 'invalid_grant'
  | 'unauthorized_client'
  | 'unsupported_grant_type'
  | 'invalid_scope'
  | 'missing_redirect_uri';

const Error = (): JSX.Element => {
  const intl = useIntl();

  const urlParams = new URLSearchParams(window.location.search);
  const error: oAuthError | null = urlParams.get('error') as unknown as oAuthError;

  const getErrorTitle = (error: oAuthError): string => {
    switch (error) {
      case null:
        return 'error';
      case 'missing_redirect_uri':
        return intl.formatMessage({ id: 'missingRedirectTitle' });
      default:
        return error;
    }
  };
  const getErrorDescription = (error: oAuthError): string => {
    if (error === 'missing_redirect_uri') {
      return intl.formatMessage({ id: 'missingRedirectMessage' });
    }
    return urlParams.get('error_description') ?? '';
  };

  return (
    <ErrorDialog
      title={getErrorTitle(error)}
      message={getErrorDescription(error)}
      buttonText='returnToHome'
      onClick={
        error === 'missing_redirect_uri'
          ? undefined
          : () => {
              navigateTo(PUBLIC_URL);
            }
      }
    />
  );
};

export default Error;
